module.exports = __webpack_public_path__ + "img/reddit.6c2292ab.svg";